import { Card, CardContent, Grid2 as Grid, Typography } from '@mui/material';

export default function MetricCard({
  avatar,
  title,
  value,
  icon,
  footerIcon,
  footerTitle,
  footerDescription,
}) {
  return (
    <Card
      elevation={2}
      sx={{
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <CardContent>
        <Grid container size={12} spacing={2}>
          <Grid container size={12} spacing={1} sx={{ alignItems: 'center' }}>
            <Grid size="auto" sx={{ display: 'flex', alignItems: 'center' }}>
              {avatar}
            </Grid>
            <Grid size="auto">
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {title}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            size={12}
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            {icon && <Grid size="auto">{icon}</Grid>}
            <Grid size="auto">
              <Typography
                variant="h5"
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  '&::first-letter': {
                    textTransform: 'uppercase',
                  },
                }}
              >
                {value}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            size={12}
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            {footerIcon && <Grid size="auto">{footerIcon}</Grid>}
            {footerTitle && (
              <Grid size="auto">
                <Typography variant="caption">{footerTitle}</Typography>
              </Grid>
            )}
            <Grid size="auto">
              <Typography variant="caption">{footerDescription}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
